
import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import { BindGrid, exportToExcel, setFocus, setTitle } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { getCommonData } from '../Common/CommanServices';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";

const SalesPersonMaster = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [WarehouseOption, setWrehouseOption] = useState([]);
    const [MenuText, setMenuText] = useState("Sales Person Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        SalesPersonID: "0",
        SalesPersonCode: "",
        SalesPersonName: "",
        EmailID: "",
        MobileNo: "",
        Fax: "",
        Telephone:"",
        Remarks:"",
        Active: true,
        Warehouse: ""
    });

    const handleClear = async () => {
        setSaveData({
            SalesPersonID: "0",
            SalesPersonCode: "",
            SalesPersonName: "",
            EmailID: "",
            MobileNo: "",
            Fax: "",
            Telephone: "",
            Remarks: "",
            Active: true,
            Warehouse: ""
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)

    }
    useEffect(() => {
        setTitle('SalesPersonMaster', setOpen);
        setFocus('txtSalesPersonCode');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    useEffect(() => {
        getSalesPersonData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit =  () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);

        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdateSalesPersonMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                handleClear();
                getSalesPersonData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }
    const getSalesPersonData =  (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExSalesPersonData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'SalesPersonMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false)
        })
    }
    const handleEditData =  (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, SalesPersonID: ID
        }
        post(`${API_SERVER}/api/Master/EditSalesPersonData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    SalesPersonID: ID,
                    SalesPersonCode: editRecordJson[0]['SalesPersonCode'],
                    SalesPersonName: editRecordJson[0]['SalesPersonName'],
                    EmailID: editRecordJson[0]['EmailID'],
                    MobileNo: editRecordJson[0]['MobileNo'],
                    Fax: editRecordJson[0]['Fax'],
                    Telephone: editRecordJson[0]['TelephoneNo'],
                    Remarks: editRecordJson[0]['Remarks'],
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false),
                    Warehouse: editRecordJson[0]['Warehouse'],
                   
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

            }
            if (res.focus !== "") {
                setFocus(res.focus);
            }
            setIsLoading(false);
        })
    }
    const handleDeleteData =  (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, SalesPersonID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteSalesPersonData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus)
                getSalesPersonData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
            }
        })
    }
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getSalesPersonData();
    }
    const handleDownloadExcel = async () => {
        getSalesPersonData('E');
    }
    const getWareHouse = () => {
        setWrehouseOption([])
        let temp = {
            Type: "GetWareHouseMasterData",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let warehouseData = res.autoCompleteData || [];
                setWrehouseOption(warehouseData);
            } else {
                console.error("Error fetching salesperson data:", res.message);
                setWrehouseOption([]);
            }
        });
    }

    let WareHouseArr = []
    for (let i = 0; i < WarehouseOption.length; i++) {
        let mydata = WarehouseOption[i]?.values
        WareHouseArr.push(mydata)
    };

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Sales Person Code<span className="Required">*</span></label>
                                            <input
                                                disabled={SaveData.SalesPersonID !== "0" ? true : false}
                                                id='txtSalesPersonCode'
                                                type="text"
                                                maxLength="50"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtSalesPersonName')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter SalesPerson Code'
                                                value={SaveData.SalesPersonCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, SalesPersonCode: e.target.value.toUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Sales Person Name<span className="Required">*</span></label>
                                            <input
                                                id='txtSalesPersonName'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtWarehouse');
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter SalesPerson Name'
                                                value={SaveData.SalesPersonName}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, SalesPersonName: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtEmailID") };
                                                }}
                                                label='Ware House'
                                                placeholder="Ware House"
                                                maxLength='50'
                                                options={WareHouseArr}
                                                id='txtWarehouse'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getWareHouse()}
                                                inputValue={SaveData.Warehouse}
                                                onInputChange={(event, newInputValue) => {
                                                    setSaveData({ ...SaveData, Warehouse: newInputValue })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Email ID</label>
                                            <input
                                                id='txtEmailID'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtMobileNo')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Email ID'
                                                value={SaveData.EmailID}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, EmailID: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Mobile No</label>
                                            <input
                                                id='txtMobileNo'
                                                type="text"
                                                maxLength="15"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtTelephoneNo')
                                                        
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Mobile No'
                                                value={SaveData.MobileNo}
                                                onChange={(e) => {
                                                    let { value } = e.target
                                                    const mobileNo = value.replace(/[^0-9]/g, '')
                                                    setSaveData({
                                                        ...SaveData, MobileNo: mobileNo
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Telephone No</label>
                                            <input
                                                id='txtTelephoneNo'
                                                type="text"
                                                maxLength="20"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtFax')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Telephone No'
                                                value={SaveData.Telephone}
                                                onChange={(e) => {
                                                    let { value } = e.target
                                                    const telephone = value.replace(/[^0-9]/g, '')
                                                    setSaveData({
                                                        ...SaveData, Telephone: telephone
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Fax</label>
                                            <input
                                                id='txtFax'
                                                type="text"
                                                maxLength="20"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtRemarks')
                                                      
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Fax'
                                                value={SaveData.Fax}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Fax: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Remarks</label>
                                            <textarea
                                                rows='1'
                                                id='txtRemarks'
                                                maxLength="500"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('chkIsActive')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Remarks'
                                                value={SaveData.Remarks}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Remarks: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className='row'>
                                            <div className='col-6'>
                                                <div className="form-check form-switch">
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="activeCheckbox"
                                                    >
                                                        Active
                                                    </label>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="chkIsActive"
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('btnSave')
                                                            };
                                                        }}
                                                        checked={SaveData.Active}
                                                        onChange={(e) => {
                                                            setSaveData({
                                                                ...SaveData, Active: e.target.checked
                                                            })
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.SalesPersonID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                                </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle}  handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='SalesPersonMaster' />
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            
        </main>
    )
}
export default SalesPersonMaster